import classNames from "classnames";
import CollapsedIcon from "../../../assets/collapsed.svg";
import ExpandedIcon from "../../../assets/expanded.svg";
import styles from "./Collapsible.module.css";
import { useId } from "react";

const strings = {
  expandedAlt: "Expanded",
  collapsedAlt: "Collapsed",
};

type Props = {
  disabled?: boolean;
  isExpanded: boolean;
  onClick: () => void;
  children: React.ReactNode;
  tooltip?: React.ReactNode;
  headerText: string;
  headerSubtext?: string;
  className?: string;
};

export default function Collapsible({
  disabled,
  isExpanded,
  onClick,
  children,
  headerText,
  headerSubtext,
  tooltip,
  className,
}: Props) {
  const childrenId = useId();

  return (
    <div className={classNames(styles.header, className)}>
      <button
        disabled={disabled}
        className={styles.button}
        onClick={onClick}
        aria-expanded={isExpanded}
        aria-controls={childrenId}
      >
        <div className={styles.headerSubcontainer}>
          <span className={styles.headerText}>{headerText}</span>
          {tooltip ? tooltip : null}
        </div>
        <div className={styles.headerSubcontainer}>
          {headerSubtext ? (
            <span className={styles.headerText}>{headerSubtext}</span>
          ) : null}
          <img
            className={styles.buttonIcon}
            src={isExpanded ? ExpandedIcon : CollapsedIcon}
            alt={isExpanded ? strings.expandedAlt : strings.collapsedAlt}
            aria-hidden
          />
        </div>
      </button>
      {isExpanded ? (
        <div id={childrenId} className={styles.childrenContainer}>
          {children}
        </div>
      ) : null}
    </div>
  );
}
